import React, { useEffect } from 'react';
import { CheckCircle, Phone, Mail, ArrowLeft } from 'lucide-react';

const ThankYouPage = ({ onLeave, selectedCar }) => {
    useEffect(() => {
        // Автоматический редирект через 10 секунд
        const redirectTimer = setTimeout(() => {
            onLeave();
        }, 10000);

        // Очистка таймера при размонтировании компонента
        return () => clearTimeout(redirectTimer);
    }, [onLeave]);

    return (
        <div className="thank-you-page container">
            <div className="thank-you-content">
                <div className="thank-you-header">
                    <div className="success-icon-wrapper">
                        <CheckCircle
                            className="success-icon"
                            size={80}
                            strokeWidth={1.5}
                        />
                    </div>
                    <h1>Спасибо за вашу заявку!</h1>
                </div>

                <div className="thank-you-body">
                    <p className="thank-you-message">
                        Мы получили вашу заявку и скоро с вами свяжемся.
                        Наш менеджер подготовит для вас лучшее предложение.
                    </p>

                    {selectedCar && (
                        <div className="contact-info">
                            <h3>Выбранный автомобиль</h3>
                            <div className="contact-item">
                                <span>{selectedCar.brand} {selectedCar.model}</span>
                                <span>{selectedCar.year} год</span>
                            </div>                            <div className="contact-item">
                                <span>Цена: ₽{Math.round(selectedCar.price).toLocaleString()}</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="contact-info">
                    <h3>Как с нами связаться</h3>
                    <div className="contact-item">
                        <Phone className="contact-icon" />
                        <a href="tel:+79303330869">+79303330869</a>
                    </div>
                    <div className="contact-item">
                        <Mail className="contact-icon" />
                        <a href="mailto:support@cardealer.ru">contact.ooo.fresh169@gmail.com</a>
                    </div>
                </div>

                <div className="thank-you-footer">
                    <button
                        onClick={onLeave}
                        className="button primary"
                    >
                        <ArrowLeft size={20} />
                        Вернуться на главную
                    </button>
                </div>

                <p className="auto-redirect-notice">
                    Вы будете автоматически перенаправлены через 10 секунд
                </p>
            </div>
        </div>
    );
};

export default ThankYouPage;